import { apiJson } from "../../api/request.js";
import type {
  BlockedAccount,
  CommentReport,
  NotificationPreferences,
  ReviewCommentReportInput,
} from "../../../shared/contracts/social-safety.js";
export const listBlocks = () =>
  apiJson<{ blocked: BlockedAccount[] }>("/api/v1/social/blocks");
export const setBlock = (id: string, blocked: boolean) =>
  apiJson(`/api/v1/social/blocks/${encodeURIComponent(id)}`, {
    method: blocked ? "PUT" : "DELETE",
  });
export const reportComment = (id: string, requestId: string, reason: string) =>
  apiJson(`/api/v1/feed/comments/${id}/report`, {
    method: "POST",
    body: { requestId, reason },
  });
export const loadCommentReports = () =>
  apiJson<{ reports: CommentReport[] }>("/api/v1/admin/comment-reports");
export const reviewCommentReport = (
  id: string,
  body: ReviewCommentReportInput,
) => apiJson(`/api/v1/admin/comment-reports/${id}`, { method: "POST", body });
export const loadNotificationPreferences = () =>
  apiJson<NotificationPreferences>("/api/v1/notification-preferences");
export const saveNotificationPreferences = (body: NotificationPreferences) =>
  apiJson<NotificationPreferences>("/api/v1/notification-preferences", {
    method: "PUT",
    body,
  });
